import { Form, SubmitFormButton, useFormContext } from '@calendly/form';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useGetUserProfile } from 'common';
import { DirtyFormTracking } from 'components/core/form';
import { TabContainer } from 'features/account_settings/tabs/styles';
import { SettingsModalFooterActions } from 'features/settings_modal/footer_actions';
import { useSettingsModalLayoutOptional } from 'features/settings_modal/layout_context';
import { SlugField } from './slug-field';
import { validationSchema } from './validation-schema';
import { submitSlugUpdate } from '../../slice';
const descriptionCss = "dmibsqn";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const submitButtonCss = "s1cr9t30";
const SubmitButton = forwardRef((props, ref) => <SubmitFormButton ref={ref} {...props} className={classNames(submitButtonCss, props.className)}>
    {I18n.t('publisher.action.save_changes')}
  </SubmitFormButton>);
const MyLinkSettingsModalFooterActions = () => {
  const {
    submitForm,
    resetForm
  } = useFormContext();
  return <SettingsModalFooterActions onSave={submitForm} onCancel={resetForm} />;
};
export const MyLink = () => {
  const pageTitlePostfix = I18n.t('publisher.personal_settings.title');
  const {
    showFooterHost,
    footerHost
  } = useSettingsModalLayoutOptional() ?? {};
  usePageTitle(`${I18n.t('publisher.account_settings.navigation.my_link')} - ${pageTitlePostfix}`);
  const dispatch = useDispatch();
  const {
    slug,
    owner_id: ownerId
  } = useGetUserProfile();
  const owner = {
    id: ownerId,
    type: 'User'
  };
  const onSubmit = async (values, actions) => {
    const saved = await dispatch(submitSlugUpdate(values));
    if (saved) {
      actions?.resetForm?.({
        values
      });
    }
  };
  return <TabContainer>
      <Description>
        {I18n.t('publisher.account_settings.link_description')}
      </Description>
      <Form initialValues={{
      slug
    }} validationSchema={validationSchema({
      owner
    })} onSubmit={onSubmit}>
        <DirtyFormTracking />
        <SlugField name="slug" />
        {showFooterHost ? footerHost != null && createPortal(<MyLinkSettingsModalFooterActions />, footerHost) : <SubmitButton />}
      </Form>
    </TabContainer>;
};

require("./component.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./component.js");